// @flow

import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import Menu from './Menu';
import MenuList from './MenuList';
import type { CollapsedItem } from './NavLinks';
import styles from './CollapsedMenu.less';

type Props = {|
  /** Collapsed menu items. */
  items?: CollapsedItem[],
|};

const CollapsedMenu = (props: Props) => (
  <ul className={styles.collapsedMenuListWrap}>
    <li>
      <Menu
        triggerActive={false}
        tabType="nonlink"
        nonLinkContents={<Icon name="more-horizontal" className={styles.moreIcon} />}
      >
        {() => <MenuList>{props.items && props.items.map(item => item.contents)}</MenuList>}
      </Menu>
    </li>
  </ul>
);

CollapsedMenu.defaultProps = {
  items: [],
};

export default CollapsedMenu;
